import { Field } from '@chakra-ui/react';
import { ControllerRenderProps } from 'react-hook-form';
import { MTextarea } from '.';

interface MTextAreaCharacterLimitedProps {
  field: ControllerRenderProps<any, any>;
  maxLength?: number;
  placeholder?: string;
  isDisabled?: boolean;
}

// Must render inside `MFormField` (`Field.Root`) — `Field.HelperText` throws
// without one, and that root is what wires the count into `aria-describedby`.
export const MTextAreaCharacterLimited = ({
  field,
  maxLength = 255,
  placeholder = 'Type here...',
  isDisabled,
}: MTextAreaCharacterLimitedProps) => {
  return (
    <>
      <MTextarea
        placeholder={placeholder}
        {...field}
        value={field.value ?? ''}
        maxLength={maxLength}
        isDisabled={isDisabled}
      />
      <Field.HelperText textAlign="right">
        {field.value?.length ?? 0}/{maxLength}
      </Field.HelperText>
    </>
  );
};
